import React from "react";
import { withRouter } from "react-router-dom";
import { Dropdown } from "semantic-ui-react";

class MenuEscuelas extends React.Component {
  handleOpcionInicio = () => this.props.history.push("/escuelas/inicio");

  handleOpcionColegioConEscuelas = () =>
    this.props.history.push("/escuelas/colegios");

  handleOpcionPreinscripciones = () =>
    this.props.history.push("/preinscripciones");

  handleOpcionInscripcionesConfirmadas = () =>
    this.props.history.push("/inscripciones-confirmadas");

  render() {
    return (
      <Dropdown item simple text="Escuelas">
        <Dropdown.Menu>
          <Dropdown.Item
            icon="search"
            content="Búsquedas"
            onClick={this.handleOpcionInicio}
          />
          <Dropdown.Item
            icon="student"
            content="Colegios con Escuelas"
            onClick={this.handleOpcionColegioConEscuelas}
          />
          <Dropdown.Item
            icon="file outline"
            content="Preinscripciones"
            onClick={this.handleOpcionPreinscripciones}
          />
          <Dropdown.Item
            icon="file alternate outline"
            content="Inscripciones Confirmadas"
            onClick={this.handleOpcionInscripcionesConfirmadas}
          />
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default withRouter(MenuEscuelas);



// WEBPACK FOOTER //
// ./src/pages/appLayout/menuSuperior/MenuEscuelas.jsx